<template>
    <section class="newEntryMedia">
        <BlurCapImage :class="[{ hasMaxWidth: orientation === 'portrait', fadeIn, fadeOut }]"
            :orientation="orientation"
            :customMedia="true"
            :image="previews[activeId]"
            id="blurCapImage">
            <template slot="customMedia">
                <CarouselMedia
                    v-if="mediaType === 'carousel'"
                    :previews="previews"
                    :activeId="activeId"
                    :orientation="orientation"
                    @setActiveId="changeActiveId"
                    @setPosition="changePosition"
                    @updatePayload="changePayload"/>
                <SliderMedia
                    v-if="mediaType === 'slider'"
                    :previews="previews"
                    @updatePayload="changePayload"/>
            </template>
            <div class="orientationHandler"
                @click="changeOrientation">
                <Button class="changeOrientationButton"
                    size="fullWidth"
                    appearance="secondary"
                    prefixIcon="autorenew">
                    Change Orientation
                </Button>
                <EntryDetail
                    :entry="entryPreview"
                    :introPlaceholder="siteContent.IntroOfYourEntry"/>
            </div>
        </BlurCapImage>
    </section>
</template>

<script>
    import CarouselMedia from '@/components/journal/main/CarouselMedia'
    import SliderMedia   from '@/components/journal/main/SliderMedia'
    import EntryDetail   from '@/components/journal/main/EntryDetail'

    export default {
        name: 'NewEntryMedia',
        components: {
            CarouselMedia,
            SliderMedia,
            EntryDetail
        },
        props: {
            entryPreview: {
                type: Object,
                required: true
            },
            mediaType: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                activeId: 0,
                orientation: 'landscape',
                fadeIn: false,
                fadeOut: false,
                previews: []
            }
        },
        methods: {
            changeActiveId(newVal) {
                this.activeId = newVal
            },
            changePosition(newVal) {
                this.$emit('setPosition', newVal)
            },
            changePayload(newVal) {
                this.$emit('updatePayload', newVal)
            },
            changeOrientation() {
                this.fadeOut = true
                setTimeout(() => {
                    if(this.orientation === 'portrait') {
                        this.orientation = 'landscape'
                    } else {
                        this.orientation = 'portrait'
                    }
                    this.fadeIn = true
                }, 300)
                setTimeout(() => {
                    this.fadeOut = false
                    this.fadeIn = false
                }, 600)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../scss/variables';

    .newEntryMedia {
        width: 100%;
        margin-bottom: 1.5rem;
    }

    .hasMaxWidth {
        max-width: 32rem;
        width: 100%;
        margin: 0 auto;
    }

    .orientationHandler {
        cursor: pointer;
        height: 100%;
        margin-bottom: 4rem;

        .changeOrientationButton {
            position: absolute;
            bottom: 0;
            z-index: 1;
        }
    }

    .imageError {
        margin: 0.5rem 0 0 1rem;
    }

    .fadeOut {
        animation: fadeOut 0.3s ease-in-out;
    }

    .fadeIn {
        animation: fadeIn 0.3s ease-in-out;
    }

    @keyframes fadeOut {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @media all and (max-width: 560px) {
        .orientationHandler {
            margin-bottom: 0;

            .changeOrientationButton {
                display: none;
            }
        }
    }
</style>